/*
 * <quantity-input> steps its number field with the −/+ buttons, respecting
 * the field's min, and fires a bubbling `change` event like a typed edit.
 * Used by the product form and the cart lines.
 */

class QuantityInput extends HTMLElement {
  #abort;

  connectedCallback() {
    this.#abort = new AbortController();
    this.input = this.querySelector('input');

    this.querySelectorAll('[data-step]').forEach((button) =>
      button.addEventListener('click', () => this.#step(Number(button.dataset.step)), {
        signal: this.#abort.signal,
      })
    );
  }

  disconnectedCallback() {
    this.#abort.abort();
  }

  #step(amount) {
    const min = Number(this.input.min) || 0;
    this.input.value = Math.max(min, (Number(this.input.value) || min) + amount);
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
